import { useQuery } from "@tanstack/react-query";
import axiosInstance from "@/lib/axios";
import { academyProgramVariantEndpoint } from "@/config/endpoints";

export default function useProgramVariants() {
  const query = useQuery({
    queryKey: ["academy", "variants"],
    queryFn: async () => {
      const res = await axiosInstance.get(academyProgramVariantEndpoint);
      return res.data?.variants ?? res.data ?? [];
    },
  });

  const raw = Array.isArray(query.data) ? query.data : [];
  const data = raw.filter((v: any) => !v.name?.startsWith("[ARCHIVED]"));
  const variantSelects =
    data?.map((val: any) => ({
      value: String(val.id),
      name: val.name ?? val.title ?? "Unnamed",
    })) ?? [];

  return {
    variants: data,
    variantSelects,
    length: data.length,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
